module.exports = __webpack_public_path__ + "static/img/unfold_item6.078d435a.png";